/**
 * Debug utility - wraps console methods to only log in development
 * In production, these become no-ops
 */

const isDev = process.env.NODE_ENV === 'development';

const debug = {
  log: (...args) => {
    if (isDev) console.log('[DEBUG]', ...args);
  },
  
  info: (...args) => {
    if (isDev) console.info('[INFO]', ...args);
  },
  
  warn: (...args) => {
    if (isDev) console.warn('[WARN]', ...args);
  },
  
  error: (...args) => {
    // Always log errors, even in production
    console.error('[ERROR]', ...args);
  },
  
  group: (label) => {
    if (isDev) console.group(label);
  },
  
  groupEnd: () => {
    if (isDev) console.groupEnd();
  },
  
  table: (data) => {
    if (isDev) console.table(data);
  },
  
  // Special debug for match algorithm
  match: (...args) => {
    if (isDev) console.log('[MATCH]', ...args);
  },
  
  // Special debug for auth
  auth: (...args) => {
    if (isDev) console.log('[AUTH]', ...args);
  },
  
  // Special debug for bookings
  booking: (...args) => {
    if (isDev) console.log('[BOOKING]', ...args);
  }
};

export default debug;
